export default (state) => Object.values(state.userRoles.data)
